import { TimeHelper } from '@/helpers/TimeHelper';
import { FormAddress } from '@/models/common/address';
import { UserSettings } from './settings';
import { isValidEmail, isValidPhone } from '@/util/validators';

class UserModel {
  id;
  createdOn;
  status;
  lastLogin;
  name;
  phone;
  email;
  address;
  username;
  settings;
  roles;

  constructor(data) {
    this.populate(data || {});
  }

  get dateLastLogged() {
    return this.lastLogin ? TimeHelper.formatDate(this.lastLogin) : 'N/A';
  }

  get dateJoined() {
    return TimeHelper.formatDate(this.createdOn);
  }

  doesValidate() {
    return this.isEmailValid() && this.isNameValid() && this.isPhoneValid();
  }

  isNameValid() {
    return this.name !== '';
  }

  isEmailValid() {
    return isValidEmail(this.email);
  }

  isPhoneValid() {
    return isValidPhone(this.phone);
  }

  exportToCreate() {
    return {
      name: this.name,
      phone: this.phone,
      email: this.email
    };
  }

  toMetaUpdateJson(originalData) {
    let output = {};
    if (this.status !== originalData.status) output.status = this.status;
    return output; // TODO first check if object is empty
  }

  toDetailsUpdateJson(originalData) {
    let output = {};
    if (this.name !== originalData.name) output.name = this.name;
    if (this.phone !== originalData.phone) output.phone = this.phone;
    if (this.email !== originalData.email) output.email = this.email;
    return output; // TODO first check if object is empty
  }

  populate(data) {
    this.id = data.id || null;
    this.username = data.username || '';
    this.roles = data.roles || [];
    this.createdOn = data.createdOn || null;
    this.status = data.status || '';
    this.lastLogin = data.lastLogin || null;
    (this.name = data.name || ''), (this.phone = data.phone || ''), (this.email = data.email || '');
    this.address = new FormAddress(data.address);
    this.settings = new UserSettings(data.settings);
  }
}

export { UserModel };
